import React from "react";
import config from "../../../common/config";
import { getTeamDeadlineObj, getTrans } from "../../../common";
import moment from "moment";
import { Consume } from "../../../Context/Consumer";
import { LiveScoringContext, ConstraintsContext } from "../../../Context";

const FixturesList = (props) => {
  let { fixture, trans, ConstraintsData } = props;
  let liveScoring = props.LiveScoringData?.scoring;
  let isLiveMatch =
    fixture &&
    liveScoring?.find(
      (objLiveScoring) => fixture.MatchId === objLiveScoring.MatchId
    );

  let matchStatusClass = "",
    matchStatus = "";
  if (fixture.IsTbc == 1) {
    matchStatus = getTrans(trans, "TBC", "TBC");
  } else if (
    Number(isLiveMatch ? isLiveMatch.Status : fixture.MatchStatus) ===
      config.matchStatus.pre &&
    (isLiveMatch ? isLiveMatch.Status : fixture.IsLive) ===
      config.matchStatus.pre
  ) {
    matchStatusClass = "si-upcoming";
    let statusTitle = getTeamDeadlineObj(
      trans,
      config.WebConfig.OffSet,
      fixture.DateTime
    );
    matchStatus = statusTitle.matchTime;
  } else if (
    Number(isLiveMatch ? isLiveMatch.Status : fixture.MatchStatus) ===
      config.matchStatus.live &&
    (isLiveMatch ? isLiveMatch.Status : fixture.IsLive) ===
      config.matchStatus.live
  ) {
    matchStatusClass = "si-live";
    matchStatus = getTrans(trans, "live", "Live");
  } else if (
    Number(isLiveMatch ? isLiveMatch.Status : fixture.MatchStatus) ===
      config.matchStatus.post &&
    (isLiveMatch ? isLiveMatch.Status : fixture.IsLive) ===
      config.matchStatus.post
  ) {
    matchStatusClass = "si-completed";
    matchStatus = getTrans(trans, "ft", "FT");
  }
  return (
    <li>
      <div className={`si-fixtures__match ${matchStatusClass}`}>
        <div className="si-fixtures__team si-lhs">
          <div
            className="si-fixtures__team-logo"
            style={{
              backgroundImage: `url('${config.IMG_BASE}clubs/${fixture.HomeTeamId}.png?v=${ConstraintsData?.data?.PlayerJerseyTeamVersion}')`,
            }}
          ></div>
          <div className="si-fixtures__team-name">
            <span>{fixture.HomeTeamName}</span>
          </div>
        </div>
        <div className="si-fixtures__status">
          <span>{matchStatus}</span>
        </div>
        <div className="si-fixtures__team">
          <div
            className="si-fixtures__team-logo"
            style={{
              backgroundImage: `url('${config.IMG_BASE}clubs/${fixture.AwayTeamId}.png?v=${ConstraintsData?.data?.PlayerJerseyTeamVersion}')`,
            }}
          ></div>
          <div className="si-fixtures__team-name">
            <span>{fixture.AwayTeamName}</span>
          </div>
        </div>
      </div>
    </li>
  );
};

export default Consume(FixturesList, [LiveScoringContext, ConstraintsContext]);
